<template lang="html">
  <section class="ui-date-container">
    <!-- <div class="ui-date-head">
            <div class="ui-date-weeks">
                <div class="ui-date-week" v-for="item in weeks">{{item}}</div>
            </div>
        </div> -->
    <item
      v-for="index in count"
      :key="index"
      :index="index - 1"
      :schedule="schedule"
      v-model="current"
      :fullDays="fullDays"
      :current="current"
      :canClick="canClick"
      :showSimple="showSimple"
      :isAvailable="isAvailable"
    />
    <!-- <div class="ui-date-body" v-scrolling="toBottom" scroll-distance="30">
        </div> -->
  </section>
</template>

<script>
import item from '@/components/date/atom/item'

export default {
  props: {
    count: {
      type: Number,
      default: 6
    },
    // getCount: {
    //     type: Function,
    //     default(count) {
    //         console.log(count)
    //     }
    // },
    // 标志，true：可用时间，false：不可用时间，
    isAvailable: {
      type: Boolean,
      default: true
    },
    // 排期
    schedule: {
      type: Array,
      default() {
        return []
      }
    },
    // 排期已满的日期
    fullDays: {
      type: Array,
      default() {
        return []
      }
    },
    // 选中的日期
    defaultDate: {
      type: String
    },
    // 用于展示或可点击
    canClick: {
      type: Boolean,
      default: true
    },
    // 是否只显示当月的本周和下一周，简化显示
    showSimple: {
      type: Boolean,
      default: false
    }
  },
  components: {
    item
  },
  watch: {
    current(value) {
      this.$emit('input', value)
    },
    defaultDate() {
      this.current.time =
        this.defaultDate ||
        `${this.t.year}-${this.zerofill(this.t.month)}-${this.zerofill(
          this.t.date
        )}`
    }
  },
  data() {
    const t = this.formatTime(new Date())
    return {
      t,
      weeks: ['日', '一', '二', '三', '四', '五', '六'],
      today: '',
      current: {
        time:
          this.defaultDate ||
          `${t.year}-${this.zerofill(t.month)}-${this.zerofill(t.date)}`
      }
    }
  },
  directives: {
    scrolling: {
      bind(el, binding, vnode) {
        el.vm = {
          distance: el.getAttribute('scroll-distance'),
          scrollTop: 0,
          direction: 'down'
        }
        function scroll(x, y) {
          const scrollTop = el.scrollTop
          el.vm.direction = el.vm.scrollTop > scrollTop ? 'down' : 'up'
          el.vm.scrollTop = scrollTop
          const scrollHeight = el.scrollHeight
          const offsetHeight = el.offsetHeight
          const done =
            scrollHeight - scrollTop <=
            offsetHeight + (Number(el.vm.distance) || 40)
          if (!done || typeof binding.value !== 'function') return
          binding.value()
        }
        el.addEventListener('scroll', scroll)
      },
      inserted(el, binding, vnode) {
        el.vm.scrollTop = el.scrollTop
        const distance = el.vm.distance
        const scrollHeight = el.scrollHeight
        const offsetHeight = el.offsetHeight
        function scroll() {
          if (
            scrollHeight >= offsetHeight ||
            typeof binding.value !== 'function'
          )
            return
          binding.value()
        }
        scroll()
      }
    }
  },
  methods: {
    zerofill(number) {
      return number < 10 ? `0${number}` : number
    },
    formatTime(t) {
      const year = t.getFullYear()
      const month = t.getMonth() + 1
      const date = t.getDate()
      return {
        year,
        month,
        date
      }
    },
    toBottom() {
      // this.getCount(this.count)
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/css/mixin';

.ui-date-container {
  position: relative;
  z-index: 1;
  height: 100%;
  .ui-date-head {
    position: absolute;
    z-index: 2;
    top: 0;
    height: rem(60px);
    .ui-date-weeks {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-left: rem(25px);
      padding-right: rem(25px);
      background-color: #f9f9f9;
      .ui-date-week {
        width: rem(100px);
        text-align: center;
        font-size: rem(28px);
        color: #666;
        line-height: rem(60px);
      }
    }
  }
  .ui-date-body {
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 0;
      display: none;
    }
  }
}
</style>
